import { Grid } from '@mui/material';
import { RoutalPalette, VSpacer } from '@nx-smartmonkey/ui';

import { Project } from '../../../../../domain/project/Project';
import { TaskCanceledFields } from './TaskCanceledFields';
import { TaskCompletedFields } from './TaskCompletedFields';
import { TaskInformationFields } from './TaskInformationFields';

interface TaskFieldsProps {
  project: Project;
}

export const TaskFields = ({ project }: TaskFieldsProps) => {
  if (!project.tasks_enabled) return null;

  return (
    <Grid container direction="column">
      <Grid
        container
        direction="column"
        style={{
          borderRadius: `10px`,
          padding: `20px`,
          backgroundColor: RoutalPalette.neutral05,
        }}
      >
        <TaskInformationFields project={project} />

        <VSpacer large />

        <TaskCompletedFields project={project} />

        <VSpacer large />

        <TaskCanceledFields project={project} />
      </Grid>
      <VSpacer large />
    </Grid>
  );
};
